import { createFileRoute } from "@tanstack/react-router";
import AdminBackgroundDetailPage from "@/admin/pages/background-detail";

export const Route = createFileRoute("/admin/backgrounds/$id")({
  component: AdminBackgroundDetailPage,
});
